import { Route, Routes } from 'react-router-dom';
import MainPage from '@view/pages/Main';
import DemoPage from '@view/pages/demo/DemoPage';
import CalendarTestPage from '@view/pages/test/CalendarTestPage';
import NotFoundPage from '@view/pages/NotFound';
import Property from './Property';
import { Routes as AppRoutes } from '../routes';
import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

const createDevRoutes =
  [
    'localhost',
    '127.0.0.1',
    'booking-engine.cloudbeds.com',
    'booking-engine.dev-ga.cloudbeds-dev.com',
    'booking-engine.stage-ga.cloudbeds-dev.com',
  ].indexOf(window.location.hostname) > -1;

const Root = () => {
  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (event.detail > 1) {
        event.preventDefault();
      }
    };

    /* preventing select text on double click */
    document.addEventListener('mousedown', handleMouseDown, false);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <Box id="root">
      <Routes>
        {createDevRoutes && (
          <>
            <Route path="/" element={<MainPage />} />
            <Route path="/calendar" element={<CalendarTestPage />} />
            <Route path="/demo" element={<DemoPage />} />
          </>
        )}
        <Route path="/404" element={<NotFoundPage />} />
        <Route path={`${AppRoutes.Property}/*`} element={<Property />} />
        <Route path={`${AppRoutes.PropertyBr}/*`} element={<Property />} />
        <Route path={`/:lang${AppRoutes.Property}/*`} element={<Property />} />
        <Route
          path={`/:lang${AppRoutes.PropertyBr}/*`}
          element={<Property />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Box>
  );
};

export default Root;
